import { Phone, Mail, MapPin, MessageCircle, ArrowRight } from "lucide-react";
import { CONTACT } from "@/lib/i18n";

const ContactSection = ({ t, onOpenConsult }) => {
  const waLink = `https://wa.me/${CONTACT.whatsappRaw}`;

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative bg-white py-24 sm:py-32 border-t border-[#0a192f]/10"
    >
      <div className="bid-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <p className="bid-overline text-[#d4af37] mb-4">{t.nav.contact}</p>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-display font-black text-[#0a192f] tracking-tight leading-tight"
              data-testid="contact-title"
            >
              {t.form.title}
            </h2>
            <p className="mt-4 text-base sm:text-lg text-[#4a5568] leading-relaxed max-w-xl">
              {t.form.subtitle}
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <button
                onClick={onOpenConsult}
                data-testid="contact-cta-form"
                className="btn-primary group"
              >
                {t.form.submit}
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </button>
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-cta-whatsapp"
                className="btn-secondary"
              >
                <MessageCircle className="w-4 h-4" />
                {t.form.whatsapp}
              </a>
            </div>
          </div>

          <div className="lg:col-span-5 bg-[#0a192f] text-white p-8 sm:p-10 border border-[#d4af37]/20">
            <div className="space-y-7">
              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 flex items-center justify-center bg-[#d4af37]/10 border border-[#d4af37]/30 flex-shrink-0">
                  <Phone className="w-4 h-4 text-[#d4af37]" />
                </div>
                <div>
                  <div className="bid-overline text-[10px] text-[#d4af37] mb-1">WhatsApp Principal</div>
                  <a
                    href={waLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-display font-bold text-base hover:text-[#d4af37] transition-colors block"
                    data-testid="contact-info-phone"
                  >
                    {CONTACT.whatsappDisplay}
                  </a>
                  <a
                    href={`https://wa.me/${CONTACT.whatsappSecondaryRaw}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-white/60 hover:text-[#d4af37] transition-colors mt-0.5 block"
                  >
                    {CONTACT.whatsappSecondaryDisplay} · alternativo
                  </a>
                </div>
              </div>

              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 flex items-center justify-center bg-[#d4af37]/10 border border-[#d4af37]/30 flex-shrink-0">
                  <Mail className="w-4 h-4 text-[#d4af37]" />
                </div>
                <div className="min-w-0 w-full">
                  <div className="bid-overline text-[10px] text-[#d4af37] mb-3">Departamentos (E-mail)</div>
                  <ul className="space-y-4">
                    {CONTACT.emails.map((item, idx) => (
                      <li key={idx} className="flex flex-col gap-0.5">
                        <span className="text-[10px] font-bold text-white/50 uppercase tracking-wider">{item.label}</span>
                        <a
                          href={`mailto:${item.address}`}
                          className="font-display font-medium text-sm text-white/90 hover:text-[#d4af37] transition-colors break-all"
                        >
                          {item.address}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 flex items-center justify-center bg-[#d4af37]/10 border border-[#d4af37]/30 flex-shrink-0">
                  <MapPin className="w-4 h-4 text-[#d4af37]" />
                </div>
                <div>
                  <div className="bid-overline text-[10px] text-[#d4af37] mb-1">Endereço</div>
                  <p className="text-sm leading-relaxed text-white/90" data-testid="contact-info-address">
                    {CONTACT.address}
                  </p>
                </div>
              </div>

              <div className="pt-6 border-t border-white/10">
                <div className="bid-overline text-[10px] text-[#d4af37] mb-2">Contato Responsável</div>
                <p className="text-sm font-bold text-white">{CONTACT.contactPerson}</p>
                <p className="text-xs text-white/70 mb-3">{CONTACT.contactRole}</p>
                <p className="text-sm font-bold text-white">{CONTACT.contactPerson2}</p>
                <p className="text-xs text-white/70">{CONTACT.contactRole2}</p>
              </div>

              <div className="pt-6 border-t border-white/10">
                <div className="bid-overline text-[10px] text-[#d4af37] mb-2">CNPJ</div>
                <p className="text-sm text-white/80">{CONTACT.cnpj}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
